module.exports = __webpack_public_path__ + "f7689983b5b5cc4203f8d384b6a13071.svg";